import _ from "lodash";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";

import { TRANSLATIONS } from "../scheduler.consts";
import {
  areRulesReadyForSave,
  discardScheduleChanges,
  hasScheduleChanges,
  isScheduleEnabled,
  saveScheduleRules,
  toggleScheduleRules,
} from "../../../../store/schedules";
import { useSchedulerContext } from "../SchedulerContext";
import {
  ScheduleFormDescription,
  SchedulerFormContent,
} from "./SchedulerFormParts";
import {
  ProfileSection,
  ProfileSectionHeaderForm,
  ProfileSectionCollapseToggle,
} from "../../profileSection";
import { SchedulerSectionFooterFormControls } from "./SchedulerSectionFooterFormControls";

import "./SchedulerForm.scss";

export const SchedulerForm = ({ schedules }) => {
  const dispatch = useDispatch();
  const { profileId, type } = useSchedulerContext();
  const hasChanges = useSelector(hasScheduleChanges(profileId, type));
  const areAllRulesEnabled = useSelector(isScheduleEnabled(profileId, type));
  const [isSubmitEnabled, message] = useSelector(
    areRulesReadyForSave(profileId, type),
  );

  const toggleSchedule = (e) => {
    const enabled = e.target.checked;
    dispatch(toggleScheduleRules(profileId, type, enabled));
  };

  const handleDiscard = () => {
    dispatch(discardScheduleChanges(profileId, type));
  };

  const handleSubmit = () => {
    dispatch(saveScheduleRules(profileId, type));
  };

  useEffect(() => {
    return () => {
      dispatch(discardScheduleChanges(profileId, type));
    };
  }, [dispatch, profileId, type]);

  return (
    <ProfileSection
      className={classnames("schedule-form", type)}
      header={
        <ProfileSectionHeaderForm
          type={type}
          title={<FormattedMessage id={TRANSLATIONS[type].title} />}
          disabled={_.isEmpty(schedules)}
          checked={areAllRulesEnabled}
          hasChanges={hasChanges}
          onChange={toggleSchedule}
        />
      }
      toggle={
        <ProfileSectionCollapseToggle hasChanges={hasChanges}>
          <FormattedMessage id={TRANSLATIONS[type].toggle} />
        </ProfileSectionCollapseToggle>
      }
      description={<ScheduleFormDescription />}
      content={<SchedulerFormContent disabled={false} />}
      footer={
        <SchedulerSectionFooterFormControls
          hasChanges={hasChanges}
          discardDisabled={!hasChanges}
          submitDisabled={!isSubmitEnabled}
          discardChanges={handleDiscard}
          submitChanges={handleSubmit}
          message={message}
        />
      }
    />
  );
};

SchedulerForm.propTypes = {
  schedules: PropTypes.arrayOf(PropTypes.object).isRequired,
};
